import type { ReactElement, ReactNode } from 'react';
import { Button } from '../primitives/index.js';

export interface FilterPanelProps {
  /** Names the panel for assistive technology and for the mobile disclosure. */
  label: string;
  children: ReactNode;
  onClear: () => void;
  /** True when at least one filter is set; the clear action is hidden otherwise. */
  active: boolean;
}

/**
 * The container every filtered list uses.
 *
 * It is a `<form>` that never submits: each control applies immediately, so
 * there is no Apply button to leave a user wondering whether their choice took
 * effect. `onSubmit` is still trapped, because pressing Enter in a field would
 * otherwise reload the page.
 */
export function FilterPanel({ label, children, onClear, active }: FilterPanelProps): ReactElement {
  return (
    <form className="filter-panel" aria-label={label} onSubmit={(event) => event.preventDefault()}>
      {children}
      {active ? (
        <Button type="button" variant="ghost" onClick={onClear}>
          Clear filters
        </Button>
      ) : null}
    </form>
  );
}
